var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Digest_lines, _Digest_branches, _Digest_functions, _Digest_avg, _Digest_max;
import BaseEntity from './BaseEntity';
class Digest extends BaseEntity {
    constructor(digest) {
        super();
        _Digest_lines.set(this, null);
        _Digest_branches.set(this, null);
        _Digest_functions.set(this, null);
        _Digest_avg.set(this, null);
        _Digest_max.set(this, null);
        __classPrivateFieldSet(this, _Digest_lines, this.parseProperty(digest, 'lines'), "f");
        __classPrivateFieldSet(this, _Digest_branches, this.parseProperty(digest, 'branches'), "f");
        __classPrivateFieldSet(this, _Digest_functions, this.parseProperty(digest, 'functions'), "f");
        __classPrivateFieldSet(this, _Digest_max, this.parseProperty(digest, 'max'), "f");
        __classPrivateFieldSet(this, _Digest_avg, this.parseProperty(digest, 'avg'), "f");
        this.fnf = this.parseProperty(digest, 'fnf');
        this.fnh = this.parseProperty(digest, 'fnh');
        this.lf = this.parseProperty(digest, 'lf');
        this.lh = this.parseProperty(digest, 'lh');
        this.brf = this.parseProperty(digest, 'brf');
        this.brh = this.parseProperty(digest, 'brh');
    }
    get avg() {
        // eslint-disable-next-line no-undefined
        return __classPrivateFieldGet(this, _Digest_avg, "f") ?? undefined;
    }
    get branches() {
        // eslint-disable-next-line no-undefined
        return __classPrivateFieldGet(this, _Digest_branches, "f") ?? undefined;
    }
    get functions() {
        // eslint-disable-next-line no-undefined
        return __classPrivateFieldGet(this, _Digest_functions, "f") ?? undefined;
    }
    get lines() {
        // eslint-disable-next-line no-undefined
        return __classPrivateFieldGet(this, _Digest_lines, "f") ?? undefined;
    }
    get max() {
        // eslint-disable-next-line no-undefined
        return __classPrivateFieldGet(this, _Digest_max, "f") ?? undefined;
    }
}
_Digest_lines = new WeakMap(), _Digest_branches = new WeakMap(), _Digest_functions = new WeakMap(), _Digest_avg = new WeakMap(), _Digest_max = new WeakMap();
export default Digest;
